module.exports = __webpack_public_path__ + "static/media/Platinum-Host-Distributor.3a7ada0e.png";